import { ncAuchProxy } from './index';
// proxy/ncAuth/1.0/

/* [ 메뉴 ] */
// 전체메뉴조회
function getAllMenuList(params) {
  return ncAuchProxy.get('mobile/menu/list', { params });
}

export { getAllMenuList };
